import { historyService } from './history';
import { navigationHistoryService } from './navigationHistory';
import { normalizeBibleHistoryPath } from './bibleHistoryPaths';

/** Книга «Бытие» в API (id = 1 для синодального и др. переводов в этом приложении) */
export const DEFAULT_GENESIS_BOOK_ID = 1;
export const DEFAULT_FIRST_CHAPTER = 1;

/**
 * Куда вести пользователя с «главной» Библии `/:translation`:
 * — последняя запись истории с этим переводом (глава или стих);
 * — иначе Бытие 1.
 */
export function getBibleResumePath(translation) {
  const t = translation || 'kjv';

  try {
    navigationHistoryService.removeMainPageFromHistory();
  } catch {
    // тихо
  }

  const history = historyService.getHistory();

  for (const item of history) {
    if (!item?.url) continue;
    const norm = normalizeBibleHistoryPath(item.url);
    const parts = norm.split('/').filter(Boolean);
    if (parts.length < 2) continue;
    if (parts[0] !== t) continue;

    if (parts.length === 2) {
      return `/${parts[0]}/${parts[1]}/${DEFAULT_FIRST_CHAPTER}`;
    }

    return norm;
  }

  return `/${t}/${DEFAULT_GENESIS_BOOK_ID}/${DEFAULT_FIRST_CHAPTER}`;
}
